<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <div>
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-user" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-1 font-weight-bold">{{ dependent.full_name || 'Dependent Profile' }}</h4>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <span v-if="dependent.status == 'active'" class="header-status header-status--active">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
                <span v-else class="header-status header-status--inactive">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
                <span class="header-id-badge" v-if="dependent.id_card_number">
                  {{ dependent.id_card_number }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="container mt-n3 pb-5">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="card table-card shadow mb-4">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-user" style="font-size: 12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Dependent Details</h6>
                </div>

                <div class="card-body row">
                  <div class="col-md-4">
                    <!-- <vue-initials-img
                      :name="dependent.firstname + ' ' + dependent.lastname"
                      class="text-center rounded-circle"
                      v-if="dependent.image == null"
                    /> -->
                    <div class="" v-if="dependent.image != null">
                      <img
                        :src="`https://claimify-api.hayokmedicare.ng/image/${dependent.image}`"
                        class="img-thumbnail"
                        width="304"
                        height="236"
                        onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
                      />
                    </div>
                  </div>

                  <div class="col-md-8 p-0">
                    <ul class="list-unstyled mb-0">
                      <li class="info-row">
                        <i class="fe fe-user info-icon"></i>
                        <div>
                          <p class="info-label">Name</p>
                          <p class="info-value">{{ dependent.firstname }} {{ dependent.lastname }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-credit-card info-icon"></i>
                        <div>
                          <p class="info-label">KGSHIA ID</p>
                          <p class="info-value"><span class="code-chip">{{ dependent.id_card_number }}</span></p>
                        </div>
                      </li>
                      <li class="info-row" v-if="dependent.user != null">
                        <i class="fe fe-users info-icon"></i>
                        <div>
                          <p class="info-label">Principal</p>
                          <p class="info-value">
                            {{ dependent.user.full_name }}
                            <span class="code-chip ml-1">{{ dependent.user.id_card_number }}</span>
                          </p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-phone info-icon"></i>
                        <div>
                          <p class="info-label">Phone Number</p>
                          <p class="info-value">{{ dependent.phone_number }}</p>
                        </div>
                      </li>
                      <li class="info-row" v-if="dependent.localgovt != null">
                        <i class="fe fe-map-pin info-icon"></i>
                        <div>
                          <p class="info-label">LGA</p>
                          <p class="info-value">{{ dependent.localgovt.local_name }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-gift info-icon"></i>
                        <div>
                          <p class="info-label">Date of Birth</p>
                          <p class="info-value">{{ dependent.dob | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-user info-icon"></i>
                        <div>
                          <p class="info-label">Gender</p>
                          <p class="info-value">{{ dependent.gender }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-link info-icon"></i>
                        <div>
                          <p class="info-label">Relationship Type</p>
                          <p class="info-value">{{ dependent.relationShipType }}</p>
                        </div>
                      </li>
                      <li class="info-row">
                        <i class="fe fe-calendar info-icon"></i>
                        <div>
                          <p class="info-label">Expiry Date</p>
                          <p class="info-value">{{ dependent.expiry_date | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal fade"
            id="example_01"
            tabindex="-1"
            role="dialog"
            aria-labelledby="example_02"
            aria-hidden="true"
          >
            <div
              class="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div class="modal-content">
                <div class="container-fluid">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div class="row">
                    <div class="col-md-12 p-t-20 p-b-20">
                      <video
                        id="video"
                        width="100%"
                        height="auto"
                        autoplay
                      ></video>
                      <p>
                        <!-- <button id="snap" class="bg-navy btn btn-flat">Snap Photo</button> -->
                        <button @click="takePic" class="bg-navy btn btn-flat">
                          Snap Photo
                        </button>
                        <button
                          type="button"
                          class="btn btn-info"
                          name="button"
                          @click="savePic"
                        >
                          Save pic
                        </button>
                      </p>
                      <!-- <p> i am image  <img :src="imagefile" alt=""> </p> -->
                      <!-- <p>{{imagefile}}</p> -->

                      <canvas id="canvas" width="720px" height="550px"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal Ends -->

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import { WebCam } from "vue-web-cam";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      dependent: "",
      notes: "",
      medications: "",
      image: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      imagefile: "",
      pictureShower: true,
    };
  },
  mounted() {
    //
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
      .then((response) => {
        this.dependent = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    attachPic(event) {
      this.user = JSON.parse(localStorage.getItem("user"));

      console.log(event);
      // let files = event.target.files
      // let filename = event.target.files[0].name
      this.image = event.target.files[0];
      this.uploadPic();
    },
    uploadPic() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      var formData = new FormData();
      formData.append("user_image", this.image);
      formData.append("dependant_id", this.$route.params.id);
      this.axios
        .post(
          "/api/v1/auth/uploadDependantImage",
          // {user_image: this.image, dependant_id: this.$route.params.id}
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        });
    },
    takePic() {
      var video = document.getElementById("video");
      var canvas = document.getElementById("canvas");
      var context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, 640, 480);

      // get image
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      console.log(image);
      localStorage.setItem("snap", this.imagefile.src);
      this.imagefile = image.src;

      // upload image

      // end of upload image
    },

    savePic() {
      this.axios
        .post(`/api/v1/auth/uploadcustomerpicImage`, {
          user_image: this.imagefile,
          user_id: this.$route.params.id,
        })
        .then((response) => {
          console.log(response);
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          this.fetchUser();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
        .then((response) => {
          this.dependent = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    uploadPicSnapped() {
      this.isLoading = true;
      let snap = localStorage.getItem("snap");

      var formData = new FormData();
      formData.append("user_image", snap);
      this.axios
        .post("/api/v1/auth/uploadUserImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Profile Image changed Successfully!", {
            position: "top-right",
          });
          // this.getUser()
        });
    },
  },
  created() {
    this.fetchUser();
  },
};
</script>
<style >
#container {
  margin: 0px auto;
  width: 500px;
  height: 375px;
  border: 10px #333 solid;
}
#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
</style>
